<template>
  <div id="nav">


<img alt="BOS logo" src="../assets/img/BOS-Logo-dark.png" height="200" > <br/><br />

<h1>404 - Oops! The page does not exist.</h1>
<h2>Looks like something went wrong.</h2>   
    <h2><a href="http://bosastrology.com">Get back on track.</a></h2> 
  </div>
</template>


<script>
export default {

};
</script>



<style scoped>

#nav {
  padding: 0;
  width: 100%;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
	body {
		margin: 0;
		padding: 0;
		border: 0;
	}
.inline {
  position:relative;
  display: inline-flex;
  padding: 5px;
  margin: 5px;
  background-color: lightseagreen;
  }
div {
  display: unset;
}
</style>
